




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { item } from "@/components/shared/ItemSelection.vue";

@Component<ItemDropzone>({})
export default class ItemDropzone extends Vue {
  @Prop({ required: true })
  items: number[];
  @Prop({ required: true })
  itemConfig: item[];
  @Prop({ required: true })
  itemName: string;

  get nothingSelected(): boolean {
    return this.items.every((el) => el === 0);
  }
}
